<template>
   <metainfo />

  <v-app>
    <MainHeader />
    <v-main>
      <router-view />
    </v-main>
    <MainFooter />
  </v-app>
</template>

<script>
import MainFooter from "./components/common/MainFooter.vue";
import MainHeader from "./components/common/MainHeader.vue";
import setMeta from "./plugins/setMeta";
export default {
  name: "#app",
  data: () => ({
    //
  }),
  components: { MainHeader, MainFooter },
  beforeCreate(){
    setMeta({
      title:"",
      description: '온크루소프트 홈페이지 입니다.',
      path: "http://www.oncrewsoft.com/",
      keywords: '잡스케줄러,JOBMIND,배치스케줄러,배치자동화,업무자동화'

    })
  }
};
</script>
<style>
@import "@/assets/css/style.css";
@import "@/assets/css/bootstrap.css";
</style>
